import { Outlet } from "@remix-run/react";
import type { LoaderFunctionArgs, MetaFunction } from "@remix-run/node";
import { redirect } from "@remix-run/node";
import { isAuthenticatedRedirect } from "~/services/auth.server";
import { defaultMetaTagsBuilder } from "~/utils/meta";

export const meta: MetaFunction = ({ location }) => {
  const url = new URL(location.pathname, "https://app.7qz.io");
  return defaultMetaTagsBuilder({
    title: "Forgot Password",
    description: "Reset your account password",
    url: url,
  });
};

export async function loader({ request }: LoaderFunctionArgs) {
  await isAuthenticatedRedirect(request);

  const requestUrl = new URL(request.url);

  if (requestUrl.pathname === "/forgot-password") {
    return redirect("/forgot-password/email");
  } else {
    return null;
  }
}

export default function ForgotPassword() {
  return (
    <div className={"mx-auto flex h-screen max-w-2xl flex-col px-4"}>
      <div className={"h relative mx-auto mt-4 h-32 w-32"}>
        <img src={"/logo.svg"} alt={"7qz logo"} />
      </div>
      <div className={"mt-4 text-2xl text-white"}>Forgot Password</div>
      <Outlet />
    </div>
  );
}
